import { render } from "./SelectionBox.vue?vue&type=template&id=fc8ba6e0&scoped=true"
import script from "./SelectionBox.vue?vue&type=script&lang=js"
export * from "./SelectionBox.vue?vue&type=script&lang=js"

import "./SelectionBox.vue?vue&type=style&index=0&id=fc8ba6e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8ba6e0"]])

export default __exports__